<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page="15"
    class="elevation-1"
    hide-default-footer
    item-key="date"
  >
    <template v-slot:item.date="{ item }">{{
      item.date | formatDate
    }}</template>
    <template v-slot:item.adultPrice="{ item }"
      >{{ item.adultPrice }} {{ item.currency }}</template
    >
    <template v-slot:item.childPrice="{ item }"
      >{{ item.childPrice }} {{ item.currency }}</template
    >
    <template v-slot:item.infantPrice="{ item }"
      >{{ item.infantPrice }} {{ item.currency }}</template
    >
    <template v-slot:item.itemPrice="{ item }"
      >{{ item.itemPrice }} {{ item.currency }}</template
    >
    <template v-slot:item.remaining="{ item }">{{
      item.isOnRequest ? "On request" : item.remaining
    }}</template>
  </v-data-table>
</template>

<script>
export default {
  name: "item-prices-grid",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Date",
          sortable: false,
          value: "date",
        },
        {
          text: "Adult",
          sortable: false,
          value: "adultPrice",
        },
        {
          text: "Child",
          sortable: false,
          value: "childPrice",
        },
        {
          text: "Infant",
          sortable: false,
          value: "infantPrice",
        },
        {
          text: "Item",
          sortable: false,
          value: "itemPrice",
        },
        {
          text: "Rate Type",
          sortable: false,
          value: "rateTypeName",
        },
        {
          text: "Rate Plan",
          sortable: false,
          value: "ratePlan",
        },
        {
          text: "Available",
          sortable: false,
          value: "remaining",
        },
      ],
    };
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderItemQuickAddItemPricesGrid.vue